<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>

</template>

<script>
export default {
  name: 'app',
  created: function () {
    this.$store.dispatch('fetchUser')
  }
}
</script>

<style src="../node_modules/material-design-icons/iconfont/material-icons.css"></style>
<style lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/App.vue